import { useNavigate } from "react-router-dom";
import Style from "../index.module.css";

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <div className={Style.container}>
      <h1 className={Style.title}>401</h1>
      <p className={Style.text}>Você não está autorizado!</p>
      <button
        className={Style.button}
        onClick={() => navigate(-1)} 
      >
        Voltar
      </button>
    </div>
  );
};

export default Unauthorized;
